(function(){
'use strict';

// ==================== STATE ====================
var project = { name:'Nouveau plan de coupe', client:'', pieces:[], dbId:null };
var imageCache = {};
var THUMB = 80;
var PIN = '1312';
var canvas, c2d, zoomLevel = 0.3, nextPieceId = 1;
var placements = [], undoStack = [], redoStack = [];
var dragState = null;

// Fabric settings (all in mm internally, displayed in cm in UI)
var fabric = {
  laize: 1500,        // mm
  lisiere: 10,        // mm per side
  napDir: 'bi',       // 'bi' or 'uni'
  gap: 0,             // mm between pieces
  teteBech: false,    // head-to-tail allowed on uni fabric
  plyCount: 1,        // matelas plies
  pricePerMeter: 0    // EUR/m
};

// Cloud API (shared with DTF)
var API_URL = 'https://nesting-dtf-api.reworkeddpt.workers.dev';
var API_PIN_VAL = '1312';
function apiCall(method, path, body) {
  var opts = { method: method, headers: { 'X-Pin': API_PIN_VAL, 'Content-Type': 'application/json' } };
  if (body) opts.body = JSON.stringify(body);
  return fetch(API_URL + path, opts).then(function(r) { if (!r.ok) throw new Error('API ' + r.status); return r.json(); });
}

var _q = function(id) { return document.getElementById(id); };

// ==================== PIN ====================
var pinBuf = '';
window.NP = {};
NP.pin = function(n) {
  if (pinBuf.length >= 4) return;
  pinBuf += n;
  var dots = document.querySelectorAll('.pin-dot');
  for (var i = 0; i < 4; i++) dots[i].classList.toggle('filled', i < pinBuf.length);
  if (pinBuf.length === 4) {
    if (pinBuf === PIN) { setTimeout(function() { _q('scr-pin').classList.remove('active'); _q('scr-app').classList.add('active'); renderAll(); }, 200); }
    else { dots.forEach(function(d) { d.classList.add('error'); }); setTimeout(function() { dots.forEach(function(d) { d.classList.remove('error', 'filled'); }); pinBuf = ''; }, 500); }
  }
};
NP.pinBack = function() { if (!pinBuf.length) return; pinBuf = pinBuf.slice(0, -1); var d = document.querySelectorAll('.pin-dot'); for (var i = 0; i < 4; i++) d[i].classList.toggle('filled', i < pinBuf.length); };
NP.lock = function() { _q('scr-app').classList.remove('active'); _q('scr-pin').classList.add('active'); pinBuf = ''; document.querySelectorAll('.pin-dot').forEach(function(d) { d.classList.remove('filled', 'error'); }); };

// ==================== HELPERS ====================
function toast(msg, type) {
  var c = _q('toastContainer'), t = document.createElement('div');
  t.className = 'toast toast-' + (type || 'ok'); t.textContent = msg;
  c.appendChild(t); setTimeout(function() { t.remove(); }, 3000);
}

function createThumb(dataUrl) {
  return new Promise(function(r) {
    var img = new Image(); img.onload = function() {
      var c = document.createElement('canvas');
      var s = Math.min(THUMB / img.width, THUMB / img.height, 1);
      c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      r(c.toDataURL('image/jpeg', 0.6));
    }; img.onerror = function() { r(dataUrl); }; img.src = dataUrl;
  });
}

function preloadImage(piece) {
  return new Promise(function(r) {
    if (imageCache[piece.id]) return r();
    var img = new Image(); img.onload = function() { imageCache[piece.id] = img; r(); };
    img.onerror = r; img.src = piece.dataUrl;
  });
}

function getImportDpi() { return parseFloat(_q('import-dpi').value) || 150; }

// Extract DPI from PNG pHYs chunk or JPEG JFIF header
function extractDpiFromBytes(bytes) {
  // PNG: look for pHYs chunk
  if (bytes[0] === 0x89 && bytes[1] === 0x50) { // PNG signature
    var off = 8;
    while (off < bytes.length - 12) {
      var len = (bytes[off] << 24) | (bytes[off+1] << 16) | (bytes[off+2] << 8) | bytes[off+3];
      var type = String.fromCharCode(bytes[off+4], bytes[off+5], bytes[off+6], bytes[off+7]);
      if (type === 'pHYs' && len === 9) {
        var ppuX = (bytes[off+8] << 24) | (bytes[off+9] << 16) | (bytes[off+10] << 8) | bytes[off+11];
        var ppuY = (bytes[off+12] << 24) | (bytes[off+13] << 16) | (bytes[off+14] << 8) | bytes[off+15];
        var unit = bytes[off+16];
        if (unit === 1 && ppuX > 0) return Math.round(ppuX / 39.3701); // meters to DPI
        return null;
      }
      off += 12 + len;
    }
  }
  // JPEG: look for JFIF APP0 marker
  if (bytes[0] === 0xFF && bytes[1] === 0xD8) {
    var off2 = 2;
    while (off2 < bytes.length - 10) {
      if (bytes[off2] !== 0xFF) break;
      var marker = bytes[off2+1];
      var segLen = (bytes[off2+2] << 8) | bytes[off2+3];
      if (marker === 0xE0) { // APP0 JFIF
        var densUnit = bytes[off2+9];
        var xDens = (bytes[off2+10] << 8) | bytes[off2+11];
        var yDens = (bytes[off2+12] << 8) | bytes[off2+13];
        if (densUnit === 1 && xDens > 0) return xDens; // already DPI
        if (densUnit === 2 && xDens > 0) return Math.round(xDens * 2.54); // dots/cm to DPI
        return null;
      }
      off2 += 2 + segLen;
    }
  }
  return null;
}

// ==================== FILE IMPORT ====================
// Import with optional known physical size (wMm, hMm) for PDFs
function importImageWithSize(name, dataUrl, knownWMm, knownHMm) {
  return new Promise(function(resolve) {
    var img = new Image();
    img.onload = function() {
      createThumb(dataUrl).then(function(thumbUrl) {
        var wMm, hMm;
        if (knownWMm && knownHMm) {
          wMm = knownWMm; hMm = knownHMm;
        } else {
          var dpi = getImportDpi();
          wMm = (img.naturalWidth / dpi) * 25.4;
          hMm = (img.naturalHeight / dpi) * 25.4;
        }
        var piece = {
          id: nextPieceId++, name: name, dataUrl: dataUrl, thumbUrl: thumbUrl,
          widthPx: img.naturalWidth, heightPx: img.naturalHeight,
          wMm: Math.round(wMm * 10) / 10, hMm: Math.round(hMm * 10) / 10,
          qty: 1, grainAngle: 0, allowMirror: false, pivotable: false,
          seamAllowance: 10,
          polygon: null
        };
        if (typeof NestEngine !== 'undefined') piece.polygon = NestEngine.extractContour(img);
        project.pieces.push(piece);
        imageCache[piece.id] = img;
        resolve();
      });
    };
    img.onerror = resolve; img.src = dataUrl;
  });
}

function importImageFromFile(file) {
  return new Promise(function(resolve) {
    // Read as ArrayBuffer first to extract DPI
    var abReader = new FileReader();
    abReader.onload = function(abEv) {
      var bytes = new Uint8Array(abEv.target.result);
      var fileDpi = extractDpiFromBytes(bytes);

      // Now read as dataURL
      var urlReader = new FileReader();
      urlReader.onload = function(urlEv) {
        var dataUrl = urlEv.target.result;
        var img = new Image();
        img.onload = function() {
          var dpi = fileDpi || getImportDpi();
          var wMm = (img.naturalWidth / dpi) * 25.4;
          var hMm = (img.naturalHeight / dpi) * 25.4;
          createThumb(dataUrl).then(function(thumbUrl) {
            var piece = {
              id: nextPieceId++, name: file.name, dataUrl: dataUrl, thumbUrl: thumbUrl,
              widthPx: img.naturalWidth, heightPx: img.naturalHeight,
              wMm: Math.round(wMm * 10) / 10, hMm: Math.round(hMm * 10) / 10,
              qty: 1, grainAngle: 0, allowMirror: false, pivotable: false,
              seamAllowance: 10, polygon: null
            };
            if (typeof NestEngine !== 'undefined') piece.polygon = NestEngine.extractContour(img);
            project.pieces.push(piece);
            imageCache[piece.id] = img;
            if (fileDpi) toast(file.name + ' : ' + dpi + ' dpi detecte', 'ok');
            resolve();
          });
        };
        img.onerror = resolve; img.src = dataUrl;
      };
      urlReader.readAsDataURL(file);
    };
    abReader.readAsArrayBuffer(file.slice(0, 1024)); // only need first 1KB for headers
  });
}

function importPDF(file) {
  if (typeof pdfjsLib === 'undefined') { toast('pdf.js non charge', 'err'); return Promise.resolve(); }
  return new Promise(function(resolve) {
    var reader = new FileReader();
    reader.onload = function(ev) {
      var data = new Uint8Array(ev.target.result);
      pdfjsLib.getDocument({ data: data }).promise.then(function(pdf) {
        var chain = Promise.resolve();
        for (var pg = 1; pg <= pdf.numPages; pg++) {
          (function(pageNum) {
            chain = chain.then(function() {
              return pdf.getPage(pageNum).then(function(page) {
                // PDF viewport at scale 1 = 72 points/inch
                var vp1 = page.getViewport({ scale: 1 });
                var realWMm = (vp1.width / 72) * 25.4;  // points to mm
                var realHMm = (vp1.height / 72) * 25.4;
                // Render at 3x for quality
                var vp = page.getViewport({ scale: 3 });
                var cv = document.createElement('canvas');
                cv.width = Math.round(vp.width); cv.height = Math.round(vp.height);
                return page.render({ canvasContext: cv.getContext('2d'), viewport: vp }).promise.then(function() {
                  var pageName = file.name.replace(/\.pdf$/i, '') + (pdf.numPages > 1 ? ' (p' + pageNum + ')' : '');
                  return importImageWithSize(pageName, cv.toDataURL('image/png'), realWMm, realHMm);
                });
              });
            });
          })(pg);
        }
        chain.then(resolve);
      }).catch(function(e) { toast('Erreur PDF: ' + e.message, 'err'); resolve(); });
    };
    reader.readAsArrayBuffer(file);
  });
}

function handleFiles(files) {
  var batch = [];
  for (var i = 0; i < files.length; i++) {
    (function(f) {
      if (f.type === 'application/pdf' || f.name.match(/\.pdf$/i)) {
        batch.push(importPDF(f));
      } else if (f.type.match(/image\/(png|jpeg|svg\+xml)/)) {
        batch.push(importImageFromFile(f));
      }
    })(files[i]);
  }
  Promise.all(batch).then(function() { renderPieceList(); toast(batch.length + ' piece(s) importee(s)', 'ok'); });
}

var $dz = _q('drop-zone'), $fi = _q('file-input');
$dz.addEventListener('dragover', function(e) { e.preventDefault(); $dz.classList.add('dragover'); });
$dz.addEventListener('dragleave', function() { $dz.classList.remove('dragover'); });
$dz.addEventListener('drop', function(e) { e.preventDefault(); $dz.classList.remove('dragover'); handleFiles(e.dataTransfer.files); });
$fi.addEventListener('change', function(e) { handleFiles(e.target.files); e.target.value = ''; });

// ==================== PIECE LIST ====================
function renderPieceList() {
  var ct = _q('pieces-container'); ct.innerHTML = '';
  project.pieces.forEach(function(p) {
    var div = document.createElement('div'); div.className = 'piece-item';
    var grainClass = p.grainAngle === 0 ? 'vertical' : 'custom';
    var grainLabel = p.grainAngle === 0 ? 'DFL \u2191' : 'DFL ' + p.grainAngle + '\u00b0';
    var wCm = (p.wMm / 10).toFixed(1), hCm = (p.hMm / 10).toFixed(1);
    div.innerHTML =
      '<img class="piece-thumb" src="' + p.thumbUrl + '" alt="">' +
      '<div class="piece-info">' +
        '<div class="piece-name-row"><input class="piece-name-input" type="text" value="' + p.name.replace(/"/g, '&quot;') + '" data-act="rename" title="Renommer"></div>' +
        '<div class="piece-dims-row">' +
          '<input class="fin dim-input" type="number" value="' + wCm + '" min="0.1" step="0.1" data-act="dimw" title="Largeur cm">' +
          '<span class="sep">\u00d7</span>' +
          '<input class="fin dim-input" type="number" value="' + hCm + '" min="0.1" step="0.1" data-act="dimh" title="Hauteur cm">' +
          '<span class="unit">cm</span>' +
        '</div>' +
        '<div class="piece-controls">' +
          '<span class="btn-icon" data-act="qm">\u2212</span>' +
          '<input class="fin qty-input" type="number" value="' + p.qty + '" min="1" max="99" data-act="qty">' +
          '<span class="btn-icon" data-act="qp">+</span>' +
          '<span class="grain-badge ' + grainClass + '">' + grainLabel + '</span>' +
          '<input class="fin grain-input" type="number" value="' + p.grainAngle + '" min="0" max="359" step="1" data-act="grain" title="Droit-fil">' +
          '<span class="btn-icon" data-act="dup" title="Dupliquer">\u229e</span>' +
          '<span class="btn-icon del" data-act="del" title="Supprimer">\u00d7</span>' +
        '</div>' +
        '<div style="margin-top:4px;display:flex;gap:10px;flex-wrap:wrap">' +
          '<label class="toggle-sw"><input type="checkbox" data-act="mirror" ' + (p.allowMirror ? 'checked' : '') + '><span class="sw"></span>Miroir</label>' +
          '<label class="toggle-sw"><input type="checkbox" data-act="pivot" ' + (p.pivotable ? 'checked' : '') + '><span class="sw"></span>Libre</label>' +
        '</div>' +
        (p.polygon && p.polygon.length >= 3 ? '<div class="poly-badge">\u2b21 ' + p.polygon.length + ' pts</div>' : '') +
      '</div>';

    div.addEventListener('change', function(e) {
      var act = e.target.dataset.act;
      if (act === 'qty') p.qty = Math.max(1, parseInt(e.target.value) || 1);
      if (act === 'grain') { p.grainAngle = Math.max(0, Math.min(359, parseInt(e.target.value) || 0)); renderPieceList(); }
      if (act === 'mirror') p.allowMirror = e.target.checked;
      if (act === 'pivot') { p.pivotable = e.target.checked; renderPieceList(); }
      if (act === 'rename') p.name = e.target.value || 'Piece';
      if (act === 'dimw') {
        var v = parseFloat(e.target.value);
        if (v > 0) { var ratio = p.hMm / p.wMm; p.wMm = Math.round(v * 100) / 10; p.hMm = Math.round(p.wMm * ratio * 10) / 10; renderPieceList(); }
      }
      if (act === 'dimh') {
        var v2 = parseFloat(e.target.value);
        if (v2 > 0) { var ratio2 = p.wMm / p.hMm; p.hMm = Math.round(v2 * 100) / 10; p.wMm = Math.round(p.hMm * ratio2 * 10) / 10; renderPieceList(); }
      }
    });
    div.addEventListener('click', function(e) {
      var act = e.target.dataset.act;
      if (act === 'qm') { p.qty = Math.max(1, p.qty - 1); renderPieceList(); }
      if (act === 'qp') { p.qty = Math.min(99, p.qty + 1); renderPieceList(); }
      if (act === 'del') { project.pieces = project.pieces.filter(function(x) { return x.id !== p.id; }); delete imageCache[p.id]; renderPieceList(); updateStats(); renderCanvas(); }
      if (act === 'dup') {
        var d = {}; for (var k in p) d[k] = p[k];
        d.id = nextPieceId++; d.name = p.name + ' (copie)';
        if (imageCache[p.id]) imageCache[d.id] = imageCache[p.id];
        project.pieces.push(d); renderPieceList();
      }
    });
    ct.appendChild(div);
  });
}

// ==================== FABRIC SETTINGS ====================
// Laize presets
_q('laize-presets').addEventListener('click', function(e) {
  if (!e.target.dataset.v) return;
  fabric.laize = parseInt(e.target.dataset.v);
  _q('laize').value = fabric.laize / 10;
  document.querySelectorAll('.btn-preset').forEach(function(b) { b.classList.toggle('active', parseInt(b.dataset.v) === fabric.laize); });
  renderCanvas();
});
_q('laize').addEventListener('change', function() {
  fabric.laize = Math.round((parseFloat(this.value) || 150) * 10);
  document.querySelectorAll('.btn-preset').forEach(function(b) { b.classList.toggle('active', parseInt(b.dataset.v) === fabric.laize); });
  renderCanvas();
});
_q('lisiere').addEventListener('change', function() { fabric.lisiere = Math.round((parseFloat(this.value) || 1) * 10); renderCanvas(); });
_q('nap-dir').addEventListener('change', function() { fabric.napDir = this.value; });
_q('piece-gap').addEventListener('change', function() { fabric.gap = Math.round((parseFloat(this.value) || 0) * 10); });
_q('ply-count').addEventListener('change', function() { fabric.plyCount = Math.max(1, parseInt(this.value) || 1); updateStats(); });
_q('price-meter').addEventListener('change', function() { fabric.pricePerMeter = parseFloat(this.value) || 0; updateStats(); });

// Tete-beche
var tbEl = _q('tete-beche');
if (tbEl) tbEl.addEventListener('change', function() { fabric.teteBech = this.checked; });

// ==================== NESTING ====================
function runNesting() {
  console.log('[NEST] Start. pieces:', project.pieces.length, 'NestEngine:', typeof NestEngine, 'NestNFP:', typeof NestNFP, 'GeometryUtil:', typeof GeometryUtil);
  if (!project.pieces.length) { toast('Aucune piece', 'err'); return; }
  if (typeof NestEngine === 'undefined') { toast('Moteur non charge', 'err'); return; }

  // Build items with overW/overH mapped to wMm/hMm
  var mappedPieces = project.pieces.map(function(p) {
    return { id: p.id, overW: p.wMm, overH: p.hMm, widthPx: p.widthPx, heightPx: p.heightPx,
      qty: p.qty, pivotable: p.pivotable, polygon: p.polygon,
      grainAngle: p.grainAngle, allowMirror: p.allowMirror };
  });
  var neItems = NestEngine.buildItems(mappedPieces, 96, { napDir: fabric.napDir });
  if (!neItems.length) { toast('Aucune piece', 'err'); return; }

  // Adaptive cell size: larger pieces need coarser grid to stay fast
  var maxDim = 0;
  neItems.forEach(function(it) { maxDim = Math.max(maxDim, it.wMm, it.hMm); });
  var cellSize = maxDim > 500 ? 3 : maxDim > 200 ? 2 : 1;

  var progEl = _q('nest-progress');
  if (progEl) progEl.style.display = 'flex';

  // Use NFP engine if available, fallback to raster
  var nestFn = (typeof NestNFP !== 'undefined') ? NestNFP.nest : NestEngine.nestGA;
  console.log('[NEST] Using:', nestFn === NestNFP.nest ? 'NestNFP' : 'NestEngine.nestGA');
  console.log('[NEST] Items:', neItems.length, 'binW:', fabric.laize, 'margins:', fabric.lisiere);
  neItems.forEach(function(it, i) { if(i < 3) console.log('[NEST] Item', i, 'area:', it.area.toFixed(0), 'poly:', it.polyMm.length, 'pts'); });

  nestFn(neItems, fabric.laize, 99999, {
    cellSize: cellSize,
    gapX: fabric.gap, gapY: fabric.gap,
    margins: { l: fabric.lisiere, r: fabric.lisiere, t: 0, b: 0 },
    isSheet: false,
    rotationStep: 90,
    saIterations: 400,
    onProgress: function(info) {
      var t = _q('nest-progress-text'), b = _q('nest-progress-bar');
      var label = info.phase === 'SA' ? 'Optimisation...' : 'Generation ' + info.generation + '/' + info.totalGenerations;
      if (t) t.textContent = label + ' \u2014 ' + info.fill.toFixed(1) + '%';
      if (b) b.style.width = (info.generation / info.totalGenerations * 100) + '%';
    }
  }).then(function(result) {
    if (progEl) progEl.style.display = 'none';
    if (!result) { toast('Erreur nesting', 'err'); return; }
    undoStack.push(JSON.parse(JSON.stringify(placements)));
    redoStack = [];
    placements = result.placements;
    toast(result.placed + '/' + result.total + ' placees (' + result.fill.toFixed(1) + '%)', result.placed < result.total ? 'err' : 'ok');
    updateStats(); renderCanvas();
  });
}

// ==================== STATS ====================
function updateStats() {
  var sLen = _q('stat-length'), sFill = _q('stat-fill'), sChute = _q('stat-chute');
  var mp = _q('metrage-panel');

  if (!placements.length) {
    sLen.textContent = '0 m'; sFill.textContent = '0%'; sChute.textContent = '0%';
    mp.innerHTML = '<div class="metrage-row"><span class="label">Aucun placement</span></div>';
    return;
  }

  var maxH = 0, usedA = 0;
  placements.forEach(function(pl) {
    maxH = Math.max(maxH, pl.y + pl.h);
    // Use polygon area if available, else bbox
    if (pl.polygon && pl.polygon.length >= 3 && typeof NestEngine !== 'undefined') {
      usedA += NestEngine.polyArea(pl.polygon);
    } else {
      usedA += pl.w * pl.h;
    }
  });

  var usableW = fabric.laize - fabric.lisiere * 2;
  var totalA = usableW * maxH;
  var fill = totalA > 0 ? (usedA / totalA * 100) : 0;
  var chute = 100 - fill;
  var metrage = maxH / 1000;
  var cout = metrage * fabric.pricePerMeter;

  sLen.textContent = metrage.toFixed(2) + ' m';
  sFill.textContent = fill.toFixed(1) + '%';
  sChute.textContent = chute.toFixed(1) + '%';

  var totalPieces = 0; project.pieces.forEach(function(p) { totalPieces += p.qty; });
  var cutsPerPly = placements.length;
  var totalCuts = cutsPerPly * fabric.plyCount;

  mp.innerHTML =
    '<div class="metrage-row"><span class="label">Laize utile</span><span class="val">' + (usableW / 10).toFixed(1) + ' cm</span></div>' +
    '<div class="metrage-row"><span class="label">Longueur</span><span class="val">' + metrage.toFixed(2) + ' m</span></div>' +
    '<div class="metrage-row"><span class="label">Pieces / pli</span><span class="val">' + cutsPerPly + ' / ' + totalPieces + '</span></div>' +
    (fabric.plyCount > 1 ? '<div class="metrage-row"><span class="label">Matelas ' + fabric.plyCount + ' plis</span><span class="val">' + totalCuts + ' pieces totales</span></div>' : '') +
    '<div class="metrage-row"><span class="label">Remplissage</span><span class="val">' + fill.toFixed(1) + '%</span></div>' +
    '<div class="metrage-row"><span class="label">Chute</span><span class="val" style="color:var(--red)">' + chute.toFixed(1) + '%</span></div>' +
    (fabric.pricePerMeter > 0 ? '<div class="metrage-row total"><span class="label">Cout tissu</span><span class="val">' + cout.toFixed(2) + ' \u20ac</span></div>' : '');
}

// ==================== CANVAS ====================
function renderCanvas() {
  if (!canvas) return;
  var totalW = fabric.laize;
  var z = zoomLevel;
  var maxH = 600;
  if (placements.length) placements.forEach(function(pl) { maxH = Math.max(maxH, pl.y + pl.h + 80); });

  var cw = totalW * z, ch = maxH * z, dpr = window.devicePixelRatio || 1;
  canvas.width = Math.ceil(cw * dpr); canvas.height = Math.ceil(ch * dpr);
  canvas.style.width = cw + 'px'; canvas.style.height = ch + 'px';
  c2d.setTransform(dpr, 0, 0, dpr, 0, 0);

  // Background
  c2d.fillStyle = '#e8e8e8'; c2d.fillRect(0, 0, cw, ch);
  // Usable area
  c2d.fillStyle = '#fff';
  c2d.fillRect(fabric.lisiere * z, 0, (totalW - fabric.lisiere * 2) * z, ch);
  // Lisiere
  c2d.fillStyle = 'rgba(180,130,200,.12)';
  c2d.fillRect(0, 0, fabric.lisiere * z, ch);
  c2d.fillRect((totalW - fabric.lisiere) * z, 0, fabric.lisiere * z, ch);
  c2d.save(); c2d.strokeStyle = '#ce93d8'; c2d.lineWidth = 1; c2d.setLineDash([6, 4]);
  c2d.beginPath();
  c2d.moveTo(fabric.lisiere * z, 0); c2d.lineTo(fabric.lisiere * z, ch);
  c2d.moveTo((totalW - fabric.lisiere) * z, 0); c2d.lineTo((totalW - fabric.lisiere) * z, ch);
  c2d.stroke(); c2d.restore();

  // Ruler (every 10cm = 100mm)
  c2d.fillStyle = 'rgba(0,0,0,.25)'; c2d.font = '8px Inter,sans-serif';
  for (var rx = 0; rx <= totalW; rx += 100) {
    var rxp = rx * z;
    c2d.fillRect(rxp, 0, 0.5, rx % 500 === 0 ? 14 : 8);
    if (rx % 500 === 0 && rx > 0) c2d.fillText((rx / 10) + '', rxp + 2, 12);
  }
  for (var ry = 0; ry <= maxH; ry += 100) {
    var ryp = ry * z;
    c2d.fillRect(0, ryp, ry % 500 === 0 ? 14 : 8, 0.5);
    if (ry % 500 === 0 && ry > 0) c2d.fillText((ry / 10) + '', 2, ryp - 3);
  }

  // Placements
  placements.forEach(function(pl, idx) {
    var px = pl.x * z, py = pl.y * z, pw = pl.w * z, ph = pl.h * z;
    var img = imageCache[pl.motifId];
    var isDrag = dragState && dragState.idx === idx;

    if (img) {
      c2d.save();
      if (pl.rotation && pl.rotation !== 0 && pl.rotation !== '0') {
        var piece = project.pieces.find(function(p) { return p.id === pl.motifId; });
        var ow = piece ? piece.wMm * z : pw, oh = piece ? piece.hMm * z : ph;
        c2d.translate(px + pw / 2, py + ph / 2);
        var rotDeg = typeof pl.rotation === 'string' ? parseInt(pl.rotation) : pl.rotation;
        c2d.rotate(rotDeg * Math.PI / 180);
        c2d.drawImage(img, -ow / 2, -oh / 2, ow, oh);
      } else {
        c2d.drawImage(img, px, py, pw, ph);
      }
      c2d.restore();
    } else {
      c2d.fillStyle = '#f0f0f0'; c2d.fillRect(px, py, pw, ph);
    }

    // Polygon or bbox outline
    if (pl.polygon && pl.polygon.length >= 3) {
      c2d.beginPath();
      c2d.moveTo(pl.polygon[0].x * z, pl.polygon[0].y * z);
      for (var pi = 1; pi < pl.polygon.length; pi++) c2d.lineTo(pl.polygon[pi].x * z, pl.polygon[pi].y * z);
      c2d.closePath();
      c2d.strokeStyle = isDrag ? '#0066cc' : 'rgba(123,31,162,0.5)';
      c2d.lineWidth = isDrag ? 2.5 : 1.5; c2d.stroke();
    } else {
      c2d.strokeStyle = isDrag ? '#0066cc' : 'rgba(0,0,0,.15)';
      c2d.lineWidth = isDrag ? 2 : 1; c2d.strokeRect(px, py, pw, ph);
    }

    // Grain line arrow
    var piece = project.pieces.find(function(p) { return p.id === pl.motifId; });
    if (piece) {
      var cx2 = px + pw / 2, cy2 = py + ph / 2;
      var arrowLen = Math.min(pw, ph) * 0.35;
      var gAngle = (piece.grainAngle || 0);
      // Adjust for placement rotation
      var pRot = typeof pl.rotation === 'string' ? parseInt(pl.rotation) || 0 : (pl.rotation || 0);
      var totalAngle = (gAngle + pRot) * Math.PI / 180;
      var ax = Math.sin(totalAngle) * arrowLen;
      var ay = -Math.cos(totalAngle) * arrowLen;

      c2d.save();
      c2d.strokeStyle = 'rgba(200,0,0,0.6)'; c2d.lineWidth = 1.5;
      c2d.beginPath(); c2d.moveTo(cx2 - ax, cy2 - ay); c2d.lineTo(cx2 + ax, cy2 + ay); c2d.stroke();
      // Arrow head
      var headLen = 5 * z;
      var headAngle = Math.atan2(ay, ax);
      c2d.beginPath();
      c2d.moveTo(cx2 + ax, cy2 + ay);
      c2d.lineTo(cx2 + ax - headLen * Math.cos(headAngle - 0.5), cy2 + ay - headLen * Math.sin(headAngle - 0.5));
      c2d.moveTo(cx2 + ax, cy2 + ay);
      c2d.lineTo(cx2 + ax - headLen * Math.cos(headAngle + 0.5), cy2 + ay - headLen * Math.sin(headAngle + 0.5));
      c2d.stroke();
      c2d.restore();
    }

    // Label
    if (pw > 30 && ph > 16 && piece) {
      var nm = piece.name.length > 20 ? piece.name.slice(0, 19) + '\u2026' : piece.name;
      c2d.fillStyle = 'rgba(123,31,162,.6)'; c2d.fillRect(px, py, Math.min(pw, 150), 18);
      c2d.fillStyle = '#fff'; c2d.font = '9px Inter,sans-serif';
      c2d.fillText(nm, px + 3, py + 12);
    }
  });

  // Cut line
  if (placements.length) {
    var maxY = 0; placements.forEach(function(pl) { maxY = Math.max(maxY, pl.y + pl.h); });
    var ly = maxY * z;
    c2d.save(); c2d.strokeStyle = '#7b1fa2'; c2d.lineWidth = 2; c2d.setLineDash([8, 4]);
    c2d.beginPath(); c2d.moveTo(0, ly); c2d.lineTo(cw, ly); c2d.stroke(); c2d.restore();
    c2d.fillStyle = '#7b1fa2'; c2d.font = 'bold 11px Inter,sans-serif';
    c2d.fillText((maxY / 1000).toFixed(2) + ' m', 4, ly - 6);
  }

  // Laize label
  c2d.fillStyle = 'rgba(0,0,0,.04)'; c2d.font = 'bold ' + Math.max(12, 24 * z) + 'px Inter,sans-serif';
  c2d.fillText((fabric.laize / 10) + ' cm', 6 * z, ch - 6 * z);
}

// ==================== DRAG & DROP ====================
function initCanvasEvents() {
  canvas.addEventListener('mousedown', function(e) {
    var r = canvas.getBoundingClientRect();
    var mx = (e.clientX - r.left) / zoomLevel, my = (e.clientY - r.top) / zoomLevel;
    for (var i = placements.length - 1; i >= 0; i--) {
      var pl = placements[i];
      if (mx >= pl.x && mx <= pl.x + pl.w && my >= pl.y && my <= pl.y + pl.h) {
        undoStack.push(JSON.parse(JSON.stringify(placements)));
        redoStack = [];
        dragState = { idx: i, ox: mx - pl.x, oy: my - pl.y };
        canvas.style.cursor = 'grabbing';
        e.preventDefault(); return;
      }
    }
  });
  canvas.addEventListener('mousemove', function(e) {
    if (!dragState) {
      var r2 = canvas.getBoundingClientRect();
      var mx2 = (e.clientX - r2.left) / zoomLevel, my2 = (e.clientY - r2.top) / zoomLevel;
      var over = false;
      for (var i = placements.length - 1; i >= 0; i--) {
        var pl2 = placements[i];
        if (mx2 >= pl2.x && mx2 <= pl2.x + pl2.w && my2 >= pl2.y && my2 <= pl2.y + pl2.h) { over = true; break; }
      }
      canvas.style.cursor = over ? 'grab' : 'default';
      return;
    }
    var r = canvas.getBoundingClientRect();
    var mx = (e.clientX - r.left) / zoomLevel, my = (e.clientY - r.top) / zoomLevel;
    var pl = placements[dragState.idx];
    pl.x = Math.max(0, mx - dragState.ox);
    pl.y = Math.max(0, my - dragState.oy);
    pl.x = Math.min(pl.x, fabric.laize - pl.w);
    // Update polygon positions
    if (pl.polygon) {
      var dx = pl.x - (pl.polygon[0] ? pl.polygon[0].x - pl.w / 2 : pl.x);
      // Recompute polygon from base poly offset
    }
    renderCanvas();
  });
  canvas.addEventListener('mouseup', function() {
    if (dragState) { dragState = null; canvas.style.cursor = 'default'; updateStats(); renderCanvas(); }
  });
  canvas.addEventListener('mouseleave', function() {
    if (dragState) { dragState = null; canvas.style.cursor = 'default'; updateStats(); renderCanvas(); }
  });
}

// ==================== UNDO / REDO ====================
function undo() { if (!undoStack.length) return; redoStack.push(JSON.parse(JSON.stringify(placements))); placements = undoStack.pop(); updateStats(); renderCanvas(); }
function redo() { if (!redoStack.length) return; undoStack.push(JSON.parse(JSON.stringify(placements))); placements = redoStack.pop(); updateStats(); renderCanvas(); }
document.addEventListener('keydown', function(e) {
  if ((e.ctrlKey || e.metaKey) && !e.altKey) {
    if (e.key === 'z' && !e.shiftKey) { e.preventDefault(); undo(); }
    else if ((e.key === 'z' && e.shiftKey) || e.key === 'y') { e.preventDefault(); redo(); }
  }
});

// ==================== SAVE / LOAD CLOUD ====================
function buildSaveData() {
  return {
    name: _q('proj-name').value || 'Sans titre',
    client: _q('proj-client').value || '',
    tool: 'patronnage',
    fabric: fabric,
    pieces: project.pieces.map(function(p) {
      return { id: p.id, name: p.name, dataUrl: p.dataUrl, widthPx: p.widthPx, heightPx: p.heightPx,
        wMm: p.wMm, hMm: p.hMm, qty: p.qty, grainAngle: p.grainAngle,
        allowMirror: p.allowMirror, pivotable: p.pivotable, seamAllowance: p.seamAllowance, polygon: p.polygon };
    }),
    placements: placements, nextPieceId: nextPieceId
  };
}

function saveProject() {
  var data = buildSaveData();
  var id = project.dbId || ('pat_' + Date.now());
  data.id = id; project.dbId = id;
  apiCall('POST', '/save', data).then(function() { toast('Projet sauvegarde', 'ok'); })
    .catch(function(e) { toast('Erreur: ' + e.message, 'err'); });
}

function loadProject(id) {
  apiCall('GET', '/load/' + id).then(function(data) {
    if (!data || data.error) { toast('Introuvable', 'err'); return; }
    project.dbId = id;
    _q('proj-name').value = data.name || '';
    _q('proj-client').value = data.client || '';
    if (data.fabric) {
      fabric = data.fabric;
      _q('laize').value = fabric.laize / 10;
      _q('lisiere').value = fabric.lisiere / 10;
      _q('nap-dir').value = fabric.napDir;
      _q('piece-gap').value = fabric.gap / 10;
      _q('ply-count').value = fabric.plyCount || 1;
      _q('price-meter').value = fabric.pricePerMeter || 0;
    }
    project.pieces = [];
    for (var k in imageCache) delete imageCache[k];
    var chain = Promise.resolve();
    (data.pieces || []).forEach(function(sp) {
      chain = chain.then(function() {
        return createThumb(sp.dataUrl).then(function(th) {
          var p = { id: sp.id, name: sp.name, dataUrl: sp.dataUrl, thumbUrl: th,
            widthPx: sp.widthPx, heightPx: sp.heightPx, wMm: sp.wMm, hMm: sp.hMm,
            qty: sp.qty, grainAngle: sp.grainAngle || 0, allowMirror: sp.allowMirror || false,
            pivotable: sp.pivotable || false, seamAllowance: sp.seamAllowance || 10, polygon: sp.polygon || null };
          project.pieces.push(p);
          return preloadImage(p).then(function() {
            if (!p.polygon && typeof NestEngine !== 'undefined' && imageCache[p.id]) p.polygon = NestEngine.extractContour(imageCache[p.id]);
          });
        });
      });
    });
    chain.then(function() {
      nextPieceId = data.nextPieceId || (project.pieces.length + 1);
      placements = data.placements || [];
      renderAll();
      toast('Projet charge', 'ok');
    });
  }).catch(function(e) { toast('Erreur: ' + e.message, 'err'); });
}

function openProjectsPanel() {
  _q('proj-overlay').classList.add('open');
  var list = _q('proj-list');
  list.innerHTML = '<div style="text-align:center;padding:20px;color:var(--aa)">Chargement...</div>';
  apiCall('GET', '/list').then(function(resp) {
    var records = (resp.projects || []).filter(function(r) { return !r.name || r.tool === 'patronnage' || r.name.match(/plan|patron|coupe/i); });
    if (!records.length) { list.innerHTML = '<div style="text-align:center;padding:40px;color:var(--aa)">Aucun projet patronnage</div>'; return; }
    list.innerHTML = '';
    records.forEach(function(rec) {
      var card = document.createElement('div'); card.className = 'proj-card';
      var dateStr = ''; try { var d = new Date(rec.modified); dateStr = d.toLocaleDateString('fr-FR'); } catch (e) {}
      card.innerHTML =
        '<div class="proj-card-info"><div class="proj-card-name">' + (rec.name || 'Sans titre') + '</div>' +
        '<div class="proj-card-meta"><span>' + (rec.client || '') + '</span><span>' + dateStr + '</span></div></div>' +
        '<div class="proj-card-actions"><span class="btn-icon" data-act="open" title="Ouvrir">&#x2197;</span>' +
        '<span class="btn-icon del" data-act="del" title="Supprimer">&times;</span></div>';
      card.addEventListener('click', function(e) {
        var act = e.target.dataset.act;
        if (act === 'del') { if (confirm('Supprimer ?')) apiCall('DELETE', '/delete/' + rec.id).then(function() { openProjectsPanel(); }); return; }
        _q('proj-overlay').classList.remove('open');
        loadProject(rec.id);
      });
      list.appendChild(card);
    });
  }).catch(function(e) { list.innerHTML = '<div style="padding:20px;color:var(--red)">Erreur: ' + e.message + '</div>'; });
}

// ==================== EXPORT PNG ====================
function exportPNG() {
  if (!placements.length) { toast('Rien a exporter', 'err'); return; }
  var maxH = 100; placements.forEach(function(pl) { maxH = Math.max(maxH, pl.y + pl.h); }); maxH += 10;
  var ec = document.createElement('canvas');
  var scale = 2;
  ec.width = Math.ceil(fabric.laize * scale); ec.height = Math.ceil(maxH * scale);
  var cx = ec.getContext('2d');
  cx.fillStyle = '#fff'; cx.fillRect(0, 0, ec.width, ec.height);
  placements.forEach(function(pl) {
    var img = imageCache[pl.motifId];
    if (img) cx.drawImage(img, pl.x * scale, pl.y * scale, pl.w * scale, pl.h * scale);
    cx.strokeStyle = 'rgba(0,0,0,.15)'; cx.lineWidth = 1;
    cx.strokeRect(pl.x * scale, pl.y * scale, pl.w * scale, pl.h * scale);
  });
  var a = document.createElement('a'); a.href = ec.toDataURL('image/png');
  a.download = 'plan-coupe-' + (project.name || 'projet').replace(/[^a-z0-9]/gi, '-') + '.png'; a.click();
}

// ==================== EXPORT PDF ====================
function exportPDF() {
  if (!placements.length) { toast('Rien a exporter', 'err'); return; }
  if (typeof window.jspdf === 'undefined') { toast('jsPDF non charge', 'err'); return; }

  var maxH = 100; placements.forEach(function(pl) { maxH = Math.max(maxH, pl.y + pl.h); }); maxH += 10;
  var jsPDF = window.jspdf.jsPDF;
  var pageW = fabric.laize; // mm
  var pageH = maxH + 80; // mm + space for cartouche

  var doc = new jsPDF({ orientation: pageW > pageH ? 'l' : 'p', unit: 'mm', format: [pageW, pageH] });

  // Render placements
  var ec = document.createElement('canvas');
  var scale = 2;
  ec.width = Math.ceil(pageW * scale); ec.height = Math.ceil(maxH * scale);
  var cx = ec.getContext('2d');
  cx.fillStyle = '#fff'; cx.fillRect(0, 0, ec.width, ec.height);
  placements.forEach(function(pl) {
    var img = imageCache[pl.motifId];
    if (img) cx.drawImage(img, pl.x * scale, pl.y * scale, pl.w * scale, pl.h * scale);
    cx.strokeStyle = 'rgba(0,0,0,.3)'; cx.lineWidth = 1;
    cx.strokeRect(pl.x * scale, pl.y * scale, pl.w * scale, pl.h * scale);
  });
  try { doc.addImage(ec.toDataURL('image/jpeg', 0.92), 'JPEG', 0, 0, pageW, maxH); } catch (e) {}

  // Cartouche
  var sy = maxH + 5;
  doc.setFontSize(12); doc.setTextColor(0);
  doc.text('PLAN DE COUPE — ' + (_q('proj-name').value || 'Projet'), 5, sy); sy += 6;
  doc.setFontSize(9);
  if (_q('proj-client').value) { doc.text('Client : ' + _q('proj-client').value, 5, sy); sy += 4; }
  doc.text('Laize : ' + (fabric.laize / 10) + ' cm | Lisiere : ' + (fabric.lisiere / 10) + ' cm/cote | Sens : ' + (fabric.napDir === 'uni' ? 'Uni-directionnel' : 'Bi-directionnel'), 5, sy); sy += 4;
  var met = maxH / 1000;
  doc.text('Metrage : ' + met.toFixed(2) + ' m' + (fabric.plyCount > 1 ? ' x ' + fabric.plyCount + ' plis' : ''), 5, sy); sy += 4;
  if (fabric.pricePerMeter > 0) { doc.text('Cout tissu : ' + (met * fabric.pricePerMeter).toFixed(2) + ' EUR', 5, sy); sy += 4; }
  sy += 2; doc.setFontSize(8); doc.text('Pieces :', 5, sy); sy += 3;
  project.pieces.forEach(function(p) {
    var cnt = placements.filter(function(pl) { return pl.motifId === p.id; }).length;
    if (cnt > 0) { doc.text('  - ' + p.name + ' : ' + cnt + 'x (' + (p.wMm / 10).toFixed(1) + ' x ' + (p.hMm / 10).toFixed(1) + ' cm)', 5, sy); sy += 3; }
  });
  doc.setFontSize(6); doc.setTextColor(150);
  doc.text('REWORK-ED Nesting Patronnage | ' + new Date().toLocaleDateString('fr-FR'), 5, pageH - 3);

  doc.save('plan-coupe-' + (_q('proj-name').value || 'projet').replace(/[^a-z0-9]/gi, '-') + '.pdf');
}

// ==================== ZOOM ====================
_q('zoom-slider').addEventListener('input', function() { zoomLevel = parseFloat(this.value); _q('zoom-label').textContent = Math.round(zoomLevel * 100) + '%'; renderCanvas(); });
_q('canvas-wrap').addEventListener('wheel', function(e) {
  if (!e.ctrlKey && !e.metaKey) return; e.preventDefault();
  zoomLevel = Math.min(2, Math.max(0.05, zoomLevel + (e.deltaY > 0 ? -0.02 : 0.02)));
  _q('zoom-slider').value = zoomLevel;
  _q('zoom-label').textContent = Math.round(zoomLevel * 100) + '%';
  renderCanvas();
}, { passive: false });

// ==================== LISTENERS ====================
_q('btn-nest').addEventListener('click', runNesting);
_q('btn-undo').addEventListener('click', undo);
_q('btn-redo').addEventListener('click', redo);
_q('btn-export-png').addEventListener('click', exportPNG);
_q('btn-export-pdf').addEventListener('click', exportPDF);
_q('btn-save').addEventListener('click', saveProject);
_q('btn-projects').addEventListener('click', openProjectsPanel);
_q('proj-close').addEventListener('click', function() { _q('proj-overlay').classList.remove('open'); });
_q('proj-overlay').addEventListener('click', function(e) { if (e.target === _q('proj-overlay')) _q('proj-overlay').classList.remove('open'); });

// ==================== RENDER ALL ====================
function renderAll() { renderPieceList(); updateStats(); renderCanvas(); }

// ==================== INIT ====================
canvas = _q('nest-canvas'); c2d = canvas.getContext('2d');
initCanvasEvents();
renderAll();

})();
